import { linkReplace } from '@loomhq/loom-embed';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  COMMENT_CONTAINER_SELECTOR,
  INLINE_COMMENT_LOOM_VIDEO_RESIZE_DELAY,
  INLINE_COMMENT_LOOM_VIDEO_SELECTOR,
} from 'constants/comments';
import {
  calculateInlineEmbedDimensions,
  updateAllEmbedWidths,
} from 'utilities/comments';

import Comment from './comment';

import './styles.less';

const CommentsContent = class extends Component {
  render() {
    const { comments, commentsEnabled } = this.props;

    let commentsDisabledClass = '';

    if (!commentsEnabled) {
      commentsDisabledClass = 'comments-disabled';
    }

    const commentComponents = comments.map(comment => {
      return <Comment key={comment.id} comment={comment} />;
    });

    return (
      <div className={`container-comments ${commentsDisabledClass}`}>
        {commentComponents}
      </div>
    );
  }

  componentWillUnmount() {
    window.removeEventListener('resize', updateAllEmbedWidths);
  }

  componentDidMount() {
    const { comments, commentsEnabled } = this.props;

    if (comments.length > 0 && commentsEnabled) {
      // expand all loom videos in the comments onLoad
      const commentContainer = document.querySelector(
        COMMENT_CONTAINER_SELECTOR
      );

      if (commentContainer) {
        linkReplace &&
          linkReplace(
            INLINE_COMMENT_LOOM_VIDEO_SELECTOR,
            calculateInlineEmbedDimensions(commentContainer.offsetWidth)
          );

        // we add this delay to make sure that the iframe has loaded and
        // there's actually something to resize
        window.setTimeout(
          updateAllEmbedWidths,
          INLINE_COMMENT_LOOM_VIDEO_RESIZE_DELAY
        );
      }
    }

    window.addEventListener('resize', updateAllEmbedWidths);
  }

  componentDidUpdate(prevProps) {
    const { comments, commentsEnabled } = this.props;

    // expand all loom videos in the comments in case of new comments
    if (prevProps.comments.length !== comments.length && commentsEnabled) {
      const commentContainer = document.querySelector(
        COMMENT_CONTAINER_SELECTOR
      );

      if (commentContainer) {
        linkReplace &&
          linkReplace(
            INLINE_COMMENT_LOOM_VIDEO_SELECTOR,
            calculateInlineEmbedDimensions(commentContainer.offsetWidth)
          );

        // we add this delay to make sure that the iframe has loaded and
        // there's actually something to resize
        window.setTimeout(
          updateAllEmbedWidths,
          INLINE_COMMENT_LOOM_VIDEO_RESIZE_DELAY
        );
      }
    }
  }
};

const mapStateToProps = state => {
  const { comments } = state.comments;
  const { comments_enabled: commentsEnabled } = state.share_video.video;

  return { comments, commentsEnabled };
};

export default connect(mapStateToProps)(CommentsContent);
